import doc                      from '@widesk-core/decorators/doc';
import AbstractPlaceStatusModel from './AbstractPlaceStatusModel';
import model                    from '@widesk-core/decorators/model';

@doc.urnResource('place_status')
@model.cacheDuration()
export default class PlaceStatusModel extends AbstractPlaceStatusModel {
	public get color() {
		switch (this.reference) {
			case 'ENABLED':
				return 'green';
			case 'DISABLED':
				return 'red';
		}
	}
}
